import { GetClientOrdersRequest } from '@/api/market-shop/orders/get-client-orders'

export const marketShopOrdersInitialFilters: GetClientOrdersRequest = {
  limit: 10,
}
